import React, { FC, useCallback, useEffect, useState } from 'react';
import IntersectionImage from 'react-intersection-image';
import cx from 'classnames';
import { Skeleton } from 'antd';

import { StoreImageTypes } from '../../../types';
import { getImageUrl } from '../../../utils';

import './styles.scss';

type LazyImageProps = {
  image?: StoreImageTypes;
  className?: string;
  style?: React.CSSProperties;
  imgClassName?: string;
  isBackground?: boolean;
};

const LazyImage: FC<LazyImageProps> = (props: LazyImageProps) => {
  const { image, className, imgClassName, isBackground, style } = props;

  const [imageSrc, setImageSrc] = useState<string>();
  const [srcLoaded, setSrcLoaded] = useState<boolean>(false);
  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement>();

  const getImageSrc = (node: HTMLDivElement) => {
    let url: string;

    if (!url) {
      let width: number;
      if (node) width = node.offsetWidth;

      url = getImageUrl(image, width);
    }

    setImageSrc(url);
  };

  useEffect(() => {
    if (imageSrc && !image) {
      setImageSrc(null);
    }

    if (wrapperRef && image) {
      getImageSrc(wrapperRef);
    }
  }, [image]);

  const onRefChange = useCallback((node: HTMLDivElement) => {
    if (!node) return;
    setWrapperRef(node);

    getImageSrc(node);
  }, []);

  return (
    <div
      ref={onRefChange}
      className={cx(
        'bds-lazy-image__wrapper',
        { 'bds-lazy-image__wrapper--background': isBackground },
        { 'bds-lazy-image__wrapper--loaded': srcLoaded },
        className
      )}
      style={style}
    >
      {!imageSrc && <Skeleton.Image className="bds-lazy-image__image--skeleton" />}
      {imageSrc && (
        <IntersectionImage
          className={cx('bds-lazy-image__image', imgClassName)}
          onLoad={() => setSrcLoaded(true)}
          src={imageSrc}
          draggable="false"
          alt={image && (image.alt || '')}
        />
      )}
    </div>
  );
};

export default React.memo(LazyImage);
